import * as actionTypes from "../actionTypes";
import * as api from "../../api/index";
import { toast } from 'react-toastify';

export const GetConversionRates = (query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
	let res, statusCode;
  try {
    const { data, status } = await api.getConversionRates(query);
		res = data;
		statusCode = status;
    if (status === 200) {
			
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data.message });
      toast.error("Something went wrong while fetching conversion rates.");
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_ERRORS, payload: error?.response?.data });
    setLoading(false);
  }
	return { res, statusCode };
};